import { useFormikContext } from 'formik';
import useAdyen, { AdyenConfig } from '../../utils/useAdyen';

// https://docs.adyen.com/payment-methods/google-pay/web-component
const AdyenGooglePayment = () => {
  const { values } = useFormikContext<{ paymentMethod: string }>();
  const isSPAY = values.paymentMethod.includes('spay');

  const adyenConfig: AdyenConfig = {
    payButton: 'google',
    withPaymentMethods: true,
    withPspSession: isSPAY
  };

  const AdyenGoogleComponent = useAdyen({ name: 'googlepay', adyenConfig, withActions: true });
  return AdyenGoogleComponent;
};

export default AdyenGooglePayment;
